const defaultTtlMs = Number(process.env.REACT_APP_DASHBOARD_CACHE_TTL_MS) || 5 * 60 * 1000

const cache = new Map()

export const getDashboardCacheTtlMs = () => defaultTtlMs

export const clearDashboardQueryCache = () => {
    cache.clear()
}

export const cachedQuery = async (key, fetcher, ttlMs = defaultTtlMs) => {
    const now = Date.now()
    const cachedEntry = cache.get(key)

    if (cachedEntry?.value && now - cachedEntry.timestamp < ttlMs) {
        return cachedEntry.value
    }

    if (cachedEntry?.promise) {
        return cachedEntry.promise
    }

    const promise = Promise.resolve()
        .then(fetcher)
        .then((value) => {
            cache.set(key, {
                value,
                timestamp: Date.now(),
            })

            return value
        })
        .catch((error) => {
            cache.delete(key)
            throw error
        })

    cache.set(key, {
        promise,
        timestamp: now,
    })

    return promise
}